import { Directive, ElementRef, HostListener, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appLowerCase]'
})
export class LowerCaseDirective {
  constructor(private el: ElementRef, @Optional() private ngControl: NgControl) {}

  @HostListener('blur') onBlur() {
    const currentValue = this.ngControl.control?.value;
    if (typeof currentValue === 'string') {
      const lowercased = this.el.nativeElement.value.toLowerCase();
      this.ngControl.control?.setValue(lowercased);
    }
  }
}
